import React, { useEffect, useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

const APP_ID = "MidnightMirth";
const POPOVER_SHOWN_KEY = APP_ID+'_tts_popover_last_shown';

const PopoverMsg = ({ anchorElementId, content }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showPopover, setShowPopover] = useState(false);

  useEffect(() => {
    const element = document.getElementById(anchorElementId);
    if (element) {
      setAnchorEl(element);
    }

    const shouldShowPopover = () => {
      const lastShownDate = localStorage.getItem(POPOVER_SHOWN_KEY);
      const today = new Date().toDateString();
      return lastShownDate !== today;
    };

    setShowPopover(shouldShowPopover());
  }, [anchorElementId]);

  const handleClose = () => {
    setShowPopover(false);
    
    // Update local storage to mark that we've shown the popover today
    const today = new Date().toDateString();
    localStorage.setItem(POPOVER_SHOWN_KEY, today);
  };

  return (
    <Popover
      open={showPopover}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <Typography sx={{ p: 2 }}>{content}</Typography>
    </Popover>
  );
};

export default PopoverMsg;